import {Utils} from '@exp1/front-utils'
import {Responses} from '../commonTypes/locations'
import {axiosInstance} from './getInstance'

export const crudApi = new Utils.CrudApi<unknown, {id: string}, Responses.List, unknown, unknown, unknown>(
  '/api/rest/locations',
  axiosInstance
)
